import { render, staticRenderFns } from "./SetupTab.vue?vue&type=template&id=74eec39c"
import script from "./SetupTab.vue?vue&type=script&lang=js"
export * from "./SetupTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports